import type { HotelCard } from '@shared/types/frontend/hotel-card';

export const isLowestPrice = ({ allPricesInfo }: HotelCard) => {
  if (!allPricesInfo?.prices?.length || allPricesInfo.prices.length === 1) {
    return true;
  }

  return allPricesInfo.prices[0].isLowest;
};
